import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from "react";
import { useDebouncedEffect } from "../Hooks/Debounce";
import { useState } from "react";

const SearchBar = ({ placeholder, changeSearchInput, className, debounceTimeMS }) => {

    const debounceTime = debounceTimeMS ?? 100;
    const [value, setValue] = useState(null)
    useDebouncedEffect(() => changeSearchInput(value), [value], debounceTime);

    const handleInputChange = (event) => {
        setValue(event.target.value);
    }

    return (
        <div className={`search-wrapper d-inline-flex ${className}`}>
            <input className="search-input" placeholder={placeholder} onChange={handleInputChange} type="text" name="search" />
            <div className="search-icon d-flex justify-content-center align-items-center">
                <FontAwesomeIcon icon={faMagnifyingGlass} />
            </div>
        </div>
    );
}

export default SearchBar;